import { Component } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { Subject } from 'rxjs';
import { CardView } from 'src/app/interfaces/cardview';

@Component({
    selector: 'app-contractpref-main',
    templateUrl: './contractpref-main.component.html',
    styleUrls: ['./contractpref-main.component.scss'],
    standalone: false
})
export class ContractprefMainComponent {

  constructor() { }

  eventsSubject: Subject<string> = new Subject<string>();
  parentRow:CardView = {};
  condition:string = '0=0'
  
  ngOnInit(): void {
  }

  onTabChanged(event:MatTabChangeEvent){
    this.eventsSubject.next(event.tab.content.templateRef.elementRef.nativeElement.id);  
  }

}
